import axios from "axios";
import Links from "../constants/Links";

/**
 * External Examiner API service for managing external examiners
 * Only HODs can perform these operations
 */
const ExternalExaminers = {
  /**
   * Create a new external examiner
   * @param {object} data - External examiner data
   * @param {string} data.name - Full name
   * @param {string} data.email - Email address
   * @param {string} data.phone - Phone number
   * @param {string} data.userid - User ID
   * @param {number} data.titleId - Title ID
   * @returns {Promise<object>}
   */
  create: async (data) => {
    return axios.post(Links.externalExaminers.create, data);
  },

  /**
   * Update an existing external examiner
   * @param {number} id - External examiner ID
   * @param {object} data - Updated external examiner data
   * @returns {Promise<object>}
   */
  update: async (id, data) => {
    return axios.put(Links.externalExaminers.update + id, data);
  },

  /**
   * Get all external examiners for HOD's department
   * @returns {Promise<object[]>}
   */
  getForDepartment: async () => {
    return axios.get(Links.externalExaminers.getForDepartment);
  },

  /**
   * Get external examiners for a specific department
   * @param {number} departmentId - Department ID
   * @returns {Promise<object[]>}
   */
  getForSpecificDepartment: async (departmentId) => {
    return axios.get(Links.externalExaminers.getForSpecificDepartment + departmentId);
  },

  /**
   * Remove external examiner role from a user
   * @param {number} id - External examiner ID
   * @returns {Promise<void>}
   */
  delete: async (id) => {
    return axios.delete(Links.externalExaminers.delete + id);
  },

  /**
   * Assign external examiner to a student
   * @param {string} studentId - Student user ID
   * @param {number} externalExaminerId - External examiner lecturer ID
   * @returns {Promise<object>}
   */
  assignToStudent: async (studentId, externalExaminerId) => {
    return axios.put(Links.externalExaminers.assignToStudent, null, {
      params: {
        studentId,
        externalExaminerId
      }
    });
  },

  /**
   * Remove external examiner from a student
   * @param {string} studentId - Student user ID
   * @returns {Promise<object>}
   */
  removeFromStudent: async (studentId) => {
    return axios.delete(Links.externalExaminers.removeFromStudent, {
      params: {
        studentId
      }
    });
  }
};

export default ExternalExaminers;